import React from "react";

function CompletePaymentLink() {
  return (
    <svg
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <rect width="32" height="32" fill="#E6FFFB" rx="8"></rect>
      <path
        stroke="#13C2C2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
        d="M17.65 22.325h-8.8a2.2 2.2 0 01-2.2-2.2v-8.25a2.2 2.2 0 012.2-2.2h13.2a2.2 2.2 0 012.2 2.2v3.85m-3.3 4.384l1.383 1.383 3.017-3.017M7.2 13.525h16.5"
      ></path>
    </svg>
  );
}

export default CompletePaymentLink;